import { render, staticRenderFns } from "./MessageRegisterInput.vue?vue&type=template&id=04967e0b&lang=pug"
import script from "./MessageRegisterInput.vue?vue&type=script&lang=ts"
export * from "./MessageRegisterInput.vue?vue&type=script&lang=ts"
import style0 from "./MessageRegisterInput.vue?vue&type=style&index=0&id=04967e0b&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports